import { calculateProjectTotalFinancialsNew } from "../../project-details/project-health/project-financials/single-project/single-project-totals.util";

export const parsedFilterData = (searchFilteredProjects, users) => {
  return searchFilteredProjects
    ?.map((projectGroup) => {
      let totalActualHours = 0;
      let totalBudgetedHours = 0;
      let totalActualServiceValue = 0;
      let totalActualExpense = 0;

      // Aggregate financials for all linked projects
      projectGroup?.linkedProjects?.forEach((project) => {
        const financials = calculateProjectTotalFinancialsNew(project, users);
        totalActualHours += financials?.expense?.hours || 0;
        totalBudgetedHours += financials?.budget?.hours || 0;
        totalActualServiceValue += financials?.expense?.cost || 0;
        totalActualExpense += financials?.expense?.actualExpense || 0;
      });

      return {
        ...projectGroup,
        tableRowId: projectGroup.id,
        estimatedServiceValue: projectGroup.estimatedServiceValue,
        materialValue: projectGroup.materialValue,
        totalValue: projectGroup.totalValue,
        totalActualHours,
        totalBudgetedHours,
        totalActualServiceValue,
        financials: {
          expense: { hours: totalActualHours, cost: totalActualServiceValue, actualCost: totalActualExpense },
          budget: { hours: totalBudgetedHours },
        },
      };
    })
    ?.sort((a, b) => {
      const clientCompare = a?.client?.localeCompare(b?.client);
      if (clientCompare !== 0) return clientCompare;
      return a?.firestoreId.localeCompare(b?.firestoreId, undefined, {
        numeric: true,
      });
    });
};
